import { defineComponent as _defineComponent } from 'vue';
import { containsHTML } from "@common/utils/DOM";
import { computed } from "vue";
import BaseErrorMessage from "./BaseErrorMessage.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'BaseFieldGroup',
  props: {
    name: null,
    label: null,
    labelClasses: null,
    secondaryText: null,
    secondaryTextClasses: null,
    note: {
      default: ""
    },
    noteClasses: null,
    errors: {
      default: () => []
    },
    required: {
      type: Boolean
    },
    inline: {
      type: Boolean
    },
    size: null
  },
  setup(__props) {
    const props = __props;
    const hasErrors = computed(() => {
      return props.errors?.length > 0;
    });
    return {
      __sfc: true,
      props,
      hasErrors,
      containsHTML,
      BaseErrorMessage
    };
  }
});